<template>
  <div :style="styles.base">
    <c-base-dialog
      :option="retainPopStyle"
      @close="closeRetainPop()"
      @confirm="confirmLeave"
      @cancel="closeRetainPop"
      v-transfer-dom
      v-model="showRetainPop"
    >
      <template slot="body">
        <div>
          <p :class="getCss('body-text')">{{ titleText }}</p>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
export default {
  name: 'CShanxianRetainPop',
  components: { [CDialog.name]: CDialog },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-retain-pop-',
      showRetainPop: false,
    };
  },
  computed: {
    retainPopStyle() {
      return Object.assign({}, this.dialogConfig, {
        header: '温馨提示',
        fotter: true,
        height: 'auto',
        confirm: true,
        cancel: true,
        confirmStyle: {
          backgroundImage: `url(${this.configurationData.confirmimage || 'https://act.xinyue.qq.com/activity/ingame/10018/1ed92b8a676d3fc25994569818b483cc.png'})`,
          margin: '0.1rem 0.3rem',
        },
        cancelStyle: {
          backgroundImage: `url(${this.configurationData.cancelImage || 'https://act.xinyue.qq.com/activity/ingame/10018/1ed92b8a676d3fc25994569818b483cc.png'})`,
          margin: '0.1rem 0.3rem',
        },
      });
    },
    titleText() {
      return this.configurationData.titleText === ''
        ? '你还有游戏大礼包未领取，确认退出吗？'
        : this.configurationData.titleText;
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      console.log('initialize');
      if (this.$isInEditor || !this.$ast.isAPP()) return;
      window?.SX_WEB.jsBridge.ui.setBackListener({
        action: 1, // 增加监听
        callback: () => {
          this.showRetainPop = true;
          this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '02', '11');
          console.log('setBackListener callback');
        },
      });
    },
    closeRetainPop() {
      this.showRetainPop = false;
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '49');
    },
    confirmLeave() {
      window?.SX_WEB.jsBridge.ui.popBack();
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '48');
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
